var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-plaid-wrap"},[_c('plaid-link',{attrs:{"clientName":"Spheremail","env":_vm.plaidSettings.env,"products":_vm.plaidSettings.products,"token":_vm.linkToken,"onLoad":_vm.onLoad,"onSuccess":_vm.onSuccess,"onExit":_vm.onExit,"onEvent":_vm.onEvent}},[_vm._t("button")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }